/**
 * @enum {string}
 * @readonly
 */
const REALMS_FORGEROCK = {
  SSLA: 'ssla',
  BR: 'br',
};

/**
 * @callback GetIsBrazilCallback
 * @param {import('axios').AxiosRequestConfig} restRequestConfig
 * @returns {string | Promise<string>}
 */

/**
 * @typedef RealmPathInterceptorCreatorParams
 * @type {object}
 * @property {GetIsBrazilCallback} [getIsBrazil]
 */

/**
 * @param {RealmPathInterceptorCreatorParams} param0
 */
export function createRealmPathInterceptor({ getIsBrazil }) {
  /**
   * @param {import('axios').AxiosRequestConfig} axiosRequestConfig
   */
  async function interceptor(axiosRequestConfig) {
    const { url } = axiosRequestConfig;
    const isBrazil = await getIsBrazil();

    if (isBrazil) {
      return {
        ...axiosRequestConfig,
        url: url.replace(`/${REALMS_FORGEROCK.SSLA}/`, `/${REALMS_FORGEROCK.BR}/`),
      };
    }

    return axiosRequestConfig;
  }

  return interceptor;
}
